import { render, staticRenderFns } from "./RiskObject.vue?vue&type=template&id=294bb91d&scoped=true"
import script from "./RiskObject.vue?vue&type=script&lang=js"
export * from "./RiskObject.vue?vue&type=script&lang=js"
import style0 from "./RiskObject.vue?vue&type=style&index=0&id=294bb91d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294bb91d",
  null
  
)

export default component.exports